// extracted by mini-css-extract-plugin
export var contentSection = "_d-8";
export var imageSection = "_d-1";
export var productGrid = "_d-0";
export var productImage = "_d-3";
export var productImageContainer = "_d-2";
export var productInfo = "_d-9";
export var purchaseControls = "_d-a";
export var quantityInput = "_d-c";
export var selectedThumbnail = "_d-6";
export var thumbnailContainer = "_d-4";
export var thumbnailImage = "_d-7";
export var thumbnailItem = "_d-5";
export var variantSelect = "_d-b";